const STORAGE_PREFIX = 'acompanha:printer-print-progress:';

/** Mesma validade do snapshot: progresso antigo não reflete mais a impressão atual. */
export const PRINTER_PRINT_PROGRESS_MAX_AGE_MS = 60 * 60 * 1000;

export function clampPrinterPrintProgressPercent(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
        return null;
    }
    return Math.min(100, Math.max(0, numeric));
}

export function isPrinterPrintProgressExpired(updatedAt, now = Date.now()) {
    const timestamp = Date.parse(String(updatedAt || ''));
    if (Number.isNaN(timestamp)) {
        return true;
    }
    return now - timestamp >= PRINTER_PRINT_PROGRESS_MAX_AGE_MS;
}

export function loadPrinterPrintProgress(printerUuid) {
    if (!printerUuid) {
        return null;
    }
    try {
        const raw = localStorage.getItem(`${STORAGE_PREFIX}${printerUuid}`);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        const percent = clampPrinterPrintProgressPercent(parsed?.percent);
        if (percent == null) {
            return null;
        }
        const updatedAt = String(parsed?.updatedAt || '').trim() || null;
        if (isPrinterPrintProgressExpired(updatedAt)) {
            localStorage.removeItem(`${STORAGE_PREFIX}${printerUuid}`);
            return null;
        }
        return { percent, updatedAt };
    } catch {
        return null;
    }
}

export function persistPrinterPrintProgress(
    printerUuid,
    percent,
    updatedAt = new Date().toISOString(),
) {
    const normalized = clampPrinterPrintProgressPercent(percent);
    if (!printerUuid || normalized == null) {
        return false;
    }
    try {
        localStorage.setItem(`${STORAGE_PREFIX}${printerUuid}`, JSON.stringify({
            percent: normalized,
            updatedAt,
        }));
        return true;
    } catch (error) {
        console.warn('[printer-print-progress] falha ao salvar no localStorage', error);
        return false;
    }
}

export function clearPrinterPrintProgress(printerUuid) {
    if (!printerUuid) {
        return;
    }
    try {
        localStorage.removeItem(`${STORAGE_PREFIX}${printerUuid}`);
    } catch {
        // ignore
    }
}

export function loadPrinterPrintProgressMap(printerUuids) {
    const map = {};
    (printerUuids || []).forEach((printerUuid) => {
        const stored = loadPrinterPrintProgress(printerUuid);
        if (stored) {
            map[printerUuid] = stored.percent;
        }
    });
    return map;
}

export function purgeObsoletePrinterPrintProgressFromStorage() {
    try {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i += 1) {
            const key = localStorage.key(i);
            if (!key?.startsWith(STORAGE_PREFIX)) {
                continue;
            }
            try {
                const parsed = JSON.parse(localStorage.getItem(key));
                if (isPrinterPrintProgressExpired(parsed?.updatedAt)) {
                    keysToRemove.push(key);
                }
            } catch {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach((key) => localStorage.removeItem(key));
    } catch {
        // ignore quota or access errors
    }
}
